import { useTranslation } from 'react-i18next'
import Bredcrumb from '../../HomeMain/Bredcrumb'
import Jobs from '../../HomeMain/Jobs'

const Main = () => {
  const { t } = useTranslation()
  return (
    <>
      <Bredcrumb title={t('pages.jobs.title')} subtitle={t('pages.jobs.subtitle')} />
      <div className="pricing-block">
        <Jobs />
      </div>
    </>
  )
}

export default Main
